// extracted by mini-css-extract-plugin
module.exports = {"nameView":"NameView_nameView__2BNYh","name":"NameView_name__3v5Lt","subname":"NameView_subname__2_wmu"};